<div
  class="container-fluid py-4"
  [class.auctions-memorabid]="isMemorabid()"
  [class.auctions-marketplace]="!isMemorabid()"
>
  <app-bid-box-header
    [isGoldAuction]="isMemorabid()"
    [isSuggestedAuction]="true"
  ></app-bid-box-header>

  <app-carousel [value]="auctionSuggestions()">
    <ng-template let-auction pTemplate="item">
      <div class="mx-1 py-3 element-dimensions">
        <app-bid-element [auction]="auction"></app-bid-element>
      </div>
    </ng-template>
  </app-carousel>

</div>
